<template>
  <div id="app">
    <!-- <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> -->
    <Navbar />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
export default {
  components: {
    Navbar,
    Footer
  },
  beforeMount() {
    this.openLoading();
  },
  methods: {
    openLoading: function() {
      const loading = this.$vs.loading({
        text: "Loading..."
      });
      setTimeout(() => {
        loading.close();
      }, 1000);
    }
  }
};
</script>

<style scoped></style>
